import * as React from 'react';
import {connect} from 'react-redux';
import * as s from './selectors';
import * as r from 'ramda';

function ImageEagerLoader({sources}) {
    return (
        <div className="hidden">
            {r.map(src => <img key={src} src={src} />, sources)}
        </div>
    );
}

export const ProductConfiguratorImage = connect((state, ownProps) => ({
    images: s.images(state),
    allImages: s.allImages(state),
}))(({images, allImages}) => {
    return (
        <React.Fragment>
            <div className="product-custom__img-wrap">
                {r.map(
                    src => (
                        <img
                            key={src}
                            src={src}
                            className="product-custom__img"
                        />
                    ),
                    images
                )}
            </div>
            <ImageEagerLoader sources={allImages} />
        </React.Fragment>
    );
});
